export const SERVICE_BOOK_UNFILLED_CODE = 'SERVICE_BOOK_UNFILLED';

/** Lead-only permission required to record a service-book override reason. */
export const SERVICE_BOOK_OVERRIDE_PERMISSION = 'work_orders.close';

export interface ServiceBookCompletionFlags {
  serviceBookChecked?: boolean | null;
  serviceBookFilled?: boolean | null;
  serviceBookType?: string | null;
}

export interface ServiceBookAudit {
  serviceBookFilledAt?: string | null;
  serviceBookFilledBy?: string | null;
  serviceBookOverrideReason?: string | null;
  serviceBookOverrideAt?: string | null;
  serviceBookOverrideBy?: string | null;
}

export function isServiceBookApplicable(flags: ServiceBookCompletionFlags): boolean {
  if (flags.serviceBookChecked === true) return true;
  const type = flags.serviceBookType;
  return type != null && type !== '';
}

export function shouldPromptServiceBookFill(input: {
  moduleEnabled: boolean;
  filled: boolean;
}): boolean {
  return input.moduleEnabled && !input.filled;
}

export function isLastIncompleteService(
  services: { bookingServiceId?: string; id?: string; status: string }[],
  serviceId: string,
): boolean {
  if (services.length === 0) return true;
  return services.every((service) => {
    const id = service.bookingServiceId ?? service.id;
    return id === serviceId || service.status === 'completed';
  });
}

export function isServiceBookUnfilledError(error: unknown): boolean {
  if (error == null || typeof error !== 'object') return false;
  if ('data' in error && error.data && typeof error.data === 'object') {
    const data = error.data as { error?: unknown; code?: unknown };
    if (data.code === SERVICE_BOOK_UNFILLED_CODE || data.error === SERVICE_BOOK_UNFILLED_CODE) {
      return true;
    }
  }
  return false;
}
